import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Transaction } from "model";

/**
 * @class Bill
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - record from the model to init class
 * @extends BCMSRecord
 * @example
 * const record = model.bills[0];
 * const document = new Bill(record);
 * @property {NUMBER} _id - The id of the bill
 * @property {STRING} _name - The name of the bill
 * @property {STRING} _logo - The logo of the bill
 * @property {bcmsCurrency} _amount - The amount of the bill
 * @property {bcmsDate} _due - The date the bill is due
 * @property {transaction} _transaction - Instance of class Transaction
 */
export default class Bill extends BCMSRecord {
    _id;
    _name;
    _logo;
    _amount;
    _due;
    _transaction;
    _isEBill;

    constructor(record) {
        super(record);
    }

    /**
     * @name getDueBills
     * @static
     * @param {ARRAY} bills - Array of Bill instances
     * @memberof Bill
     */
    static getDueBills(bills) {
        return bills.reduce((result, item) => {
            if(item.transaction == undefined) {
                result.push(item);
            }

            return result;
        }, []);
    }

    /**
     * @name getBillsPendingPayment
     * @static
     * @param {ARRAY} bills - Array of Bill instances
     * @memberof Bill
     */
    static getBillsPendingPayment(bills) {
        return bills.reduce((result, item) => {
            if(item.transaction !== undefined && item.transaction.status == "pending") {
                result.push(item);
            }

            return result;
        }, []);
    }
}

Bill.define({
    "recordType" : "bills",
    "recordIDProp" : "id",
    "className" : "Bill",
    "recordProperties" : [
        /**
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the bill
         * @property set {NUMBER} - sets the id of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToNumber("id", "_id"),
        /**
         * @name name
         * @instance
         * @property get {STRING} - gets the name of the bill
         * @property set {STRING} - sets the name of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToString("name", "_name"),
        /**
         * @name logo
         * @instance
         * @property get {STRING} - gets the logo of the bill
         * @property set {STRING} - sets the logo of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToString("logo", "_logo"),
        /**
         * @name amount
         * @instance
         * @property get {bcmsCurrency} - gets the amount of the bill
         * @property set {bcmsCurrency} - sets the amount of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToCurrency("amount", "_amount"),
        /**
         * @name due
         * @instance
         * @property get {bcmsDate} - gets the due of the bill
         * @property set {bcmsDate} - sets the due of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToDate("due", "_due"),
        /**
         * @name transaction
         * @instance
         * @property get {transaction} - gets the transaction of the bill
         * @property set {transaction} - sets the transaction of the bill
         * @memberof Bill
         */
        BCMSRecordProperty.mapToClass("transaction", "_transaction", () => Transaction),

        BCMSRecordProperty.mapToString("isEBill", "_isEBill")
    ]
});